import React from 'react';

const MongoDB_Update = () => {
  return (
    <div>
      <h1>MongoDB_Update Component</h1>
      <p>This is the MongoDB_Update page.</p>
    </div>
  );
};

export default MongoDB_Update;
